// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__qupDd","header":"Messages_header__yBmds"};